/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const MarkerIcon: React.SFC<any> = (props: any) => {
    return (
        <svg width={props.width ? props.width : `18px`} height={props.height ? props.height : `30px`} viewBox="0 0 18 30" version="1.1">
            <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Artboard-3" fill={props.color ? props.color : `#CFD8DD`}>
                    <g id="loc-pin-icon-copy">
                        <ellipse id="Oval-2-Copy" opacity="0.400000006" cx="9" cy="28" rx="6" ry="2" />
                        <path d="M9,27 C3,18.3137085 0,12.3137085 0,9 C0,4.02943725 4.02943725,0 9,0 C13.9705627,0 18,4.02943725 18,9 C18,12.3137085 15,18.3137085 9,27 Z M9,12 C10.6568542,12 12,10.6568542 12,9 C12,7.34314575 10.6568542,6 9,6 C7.34314575,6 6,7.34314575 6,9 C6,10.6568542 7.34314575,12 9,12 Z" id="Place-marker-Copy" />
                    </g>
                </g>
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Marker/Marker.tsx